import React from 'react';

import classNames from 'classnames';

import { BasicValuePropCard } from '@/components';

import { TW_HORIZONTAL_PADDINGS, TW_VERTICAL_PADDINGS } from '@/core/constants';
import { TypeBasicValuePropContainerFields } from '@/core/generated-types';

const backgroundColorMap = new Map([
  ['white', 'white'],
  ['off-white', 'yellow-pastel'],
  ['indigo pastel', 'indigo-pastel'],
]);

const GAP_SPACING_CLASSES: Record<string, string> = {
  '0': 'gap-0',
  '2': 'gap-2',
  '4': 'gap-4 md:gap-4',
  '6': 'gap-4 md:gap-6',
  '8': 'gap-4 md:gap-8',
  '10': 'gap-4 md:gap-10',
};

export const BasicValuePropContainer = (
  fields: TypeBasicValuePropContainerFields,
) => {
  const {
    backgroundColor,
    desktopLayout,
    desktopFlow,
    desktopAlignment,
    mobileAlignment,
    mobileLayout,
    valuePropCards,
    containerVerticalPadding,
    containerHorizontalPadding,
    gapSpacing,
    headerSize,
    iconSize,
    includeContainerClasses,
  } = fields;

  const desktopFlowClasses = {
    row: 'md:flex-row',
    column: 'md:flex-col',
  };

  const desktopAlignmentClasses = {
    center: 'md:justify-evenly',
    left: 'md:justify-start',
  };

  const conditionalClasses = classNames({
    'container mx-auto': includeContainerClasses,
    [desktopFlowClasses[desktopFlow]]: desktopFlow,
    [desktopAlignmentClasses[desktopAlignment]]: desktopAlignment,
  });

  const customBackgroundColor = `bg-${backgroundColorMap.get(backgroundColor)}`;

  return (
    <section
      data-testid="basic-value-prop-container"
      className={classNames(
        `w-full flex flex-col`,
        customBackgroundColor,
        TW_VERTICAL_PADDINGS[containerVerticalPadding],
        TW_HORIZONTAL_PADDINGS[containerHorizontalPadding],
        GAP_SPACING_CLASSES[gapSpacing],
        conditionalClasses,
      )}
    >
      {valuePropCards?.map((component, index) => (
        <BasicValuePropCard
          key={`${component.sys.id}-${index}`}
          {...component.fields}
          desktopLayout={desktopLayout}
          mobileLayout={mobileLayout}
          desktopAlignment={desktopAlignment}
          mobileAlignment={mobileAlignment}
          headerSize={headerSize}
          iconSize={iconSize}
        />
      ))}
    </section>
  );
};
